import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { twoFaEnabledDateState } from "oc/states/two-fa-enabled-date-state";

export const useOcTwoFactorEnabledDateState = () => {
  const state = useRecoilValue(twoFaEnabledDateState);
  const setState = useSetRecoilState(twoFaEnabledDateState);
  const resetState = useResetRecoilState(twoFaEnabledDateState);

  return {
    state,
    setState,
    resetState,
  };
};

export default useOcTwoFactorEnabledDateState;
